<template>
  <div class="englobe-params">
    <div class="params-row top">
      <FiltersMenu
        :active-filters="activeFilters"
        :is-loading="!store.filters"
        @remove-filter="removeFilterItem"
        @reset-all-filters="resetAllFilters"
      >
        <SelectMultipleCounter
          v-for="(value, key) in filtersNames"
          :key="key"
          :filter="key"
          :items="store.filters[key]"
          :active-filters="selectedFilters[key]"
          has-search
          @add-filter-item="addFilterItem"
          @remove-filter-item="removeFilterItem"
          @reset-filter="resetFilter"
        >
          {{ value }}
        </SelectMultipleCounter>
      </FiltersMenu>

      <FollawedRadioButtons
        all-match-route="/petitions"
        follawed-route="/petitions/follawed"
      />
    </div>

    <!-- Actions container : Add petition -->
    <div class="params-row">
      <SwitchSlide
        v-if="!store.isFollawedActive"
        :is-active="!store.bypassQuery"
        @toggle="toggleUseRequest"
      >
        Utiliser la requête
      </SwitchSlide>

      <button v-focus class="btn-primary" @click="openCreatePetition">
        + Ajouter une pétition
      </button>
    </div>

    <!-- Creation Pop up -->
    <CreatePetition ref="createPetitionComponent" @close="handleClose" />

    <div class="params-row">
      <TotalMatched :item-count="store.item_count" feminine />

      <DropdownMenu
        v-model="selectedLimitOption"
        :options="limitOptions"
        label="Pétitions par page :"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { storeToRefs } from "pinia";
import FiltersMenu from "@follaw-fr/components/filter-menu/organisms/FiltersMenu.vue";
import SelectMultipleCounter from "@follaw-fr/components/filter-menu/molecules/SelectMultipleCounter.vue";
import FollawedRadioButtons from "@/follaw-fr/components/reusable/atoms/FollawedRouterRadioButtons.vue";
import TotalMatched from "@follaw-fr/components/reusable/atoms/TotalMatched.vue";
import CreatePetition from "@follaw-fr/components/petitions/molecules/CreatePetition.vue";
import { usePetitionsStore } from "@follaw-fr/stores/petitions";
import SwitchSlide from "@follaw-fr/components/reusable/atoms/SwitchSlide.vue";
import { useDropdown } from "@follaw-fr/composables/useDropdown";
import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";

const store = usePetitionsStore();
const { selectedFilters } = storeToRefs(store);
const createPetitionComponent = ref(null);

const fetchPetitions = async () => {
  selectedFilters.value.from = 0;
  await store.fetchPetitionsList();
};

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters,
    filterKey: "size",
    onChange: () => {
      fetchPetitions();
    },
  });

// All filters in wanted display order with their labels
const filtersNames = {
  origin: "Origine",
  status: "Statut",
};

function openCreatePetition() {
  createPetitionComponent.value.openDialog();
}

const activeFilters = computed(() => {
  let arr = [];
  // Put all selected options from all filters with said filter name in an array for the SelectedFilters component
  Object.keys(filtersNames).forEach((key) => {
    selectedFilters.value[key]?.forEach((filter) => {
      arr = [...arr, { filter: key, item: filter }];
    });
  });

  return arr;
});

function handleClose() {
  createPetitionComponent.value.closeDialog();
}

// add Filter Items
const addFilterItem = (event) => {
  let targetFilters = selectedFilters.value[event.filter] ?? [];
  targetFilters = [...targetFilters, event.item];
  selectedFilters.value = {
    ...selectedFilters.value,
    [event.filter]: targetFilters,
  };
  fetchPetitions();
};

const removeFilterItem = (event) => {
  let targetFilters = selectedFilters.value[event.filter] ?? [];

  targetFilters = targetFilters.filter((el) => el !== event.item);

  if (targetFilters.length === 0) {
    delete selectedFilters.value[event.filter];
  } else {
    selectedFilters.value = {
      ...selectedFilters.value,
      [event.filter]: targetFilters,
    };
  }

  fetchPetitions();
};

function toggleUseRequest() {
  store.bypassQuery = !store.bypassQuery;
  fetchPetitions();
}

const resetFilter = (event) => {
  delete selectedFilters.value[event];
  fetchPetitions();
};

const resetAllFilters = () => {
  store.resetFilters();
  fetchPetitions();
};
</script>

<style scoped lang="scss">
.btn-primary {
  margin-left: auto;
}
</style>
